import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustBar from "../components/TrustBar";
import InfoBlock from "../components/InfoBlock";
import About from "../components/About";
import Reservation from "../components/Reservation";
import Happenings from "../components/Happenings";
import MenuHighlights from "../components/MenuHighlights";
import OrderOnline from "../components/OrderOnline";
import Delivery from "../components/Delivery";
import Beverages from "../components/Beverages";
import Bundles from "../components/Bundles";
import Catering from "../components/Catering";
import GoogleReviews from "../components/GoogleReviews";
import Community from "../components/Community";
import InstagramFeed from "../components/InstagramFeed";
import BlogTeaser from "../components/BlogTeaser";
import PressStrip from "../components/PressStrip";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";
import TodaysSpecialBanner from "../components/TodaysSpecialBanner";
import ExploreTiles from "../components/ExploreTiles";

export default function Home() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.12 }
    );
    const observeAll = () =>
      document.querySelectorAll(".fade-in:not(.visible)").forEach((el) => io.observe(el));
    observeAll();
    // Async sections (specials, drinks, menu) render after their API fetches —
    // watch the tree so late .fade-in nodes still get revealed.
    let raf = 0;
    const mo = new MutationObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(observeAll);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    return () => { io.disconnect(); mo.disconnect(); cancelAnimationFrame(raf); };
  }, []);

  return (
    <div className="grain">
      <Navbar />
      <Hero />
      <TrustBar />
      <div className="max-w-[1300px] mx-auto px-6 md:px-12 py-8 md:py-14">
        <TodaysSpecialBanner variant="hero" />
      </div>
      <InfoBlock />
      <About />
      <Reservation />
      <Happenings />
      <ExploreTiles />
      <MenuHighlights />
      <Bundles />
      <Beverages />
      <OrderOnline />
      <Delivery />
      <Catering />
      <GoogleReviews />
      <Community />
      <InstagramFeed />
      <BlogTeaser />
      <PressStrip />
      <Newsletter />
      <Footer />
    </div>
  );
}
